import { root } from './median-watch-time';

export const medianWatchTime = {
  ...root,
};
